export default __webpack_public_path__ + "static/media/DSC05790.47a6fcd8.jpg";